import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { SnackbarService } from "../../../services/snackbar.service";
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PhoneFollowUpPopupService } from './phone-follow-up-popup.service';

@Component({
  selector: 'phone-follow-up-popup',
  styles: [require('./phone-follow-up-popup.component.less')],
  template: require('./phone-follow-up-popup.component.html'),
  providers: [PhoneFollowUpPopupService, SnackbarService],
  preserveWhitespaces: true
})

export class PhoneFollowUpPopup {
  makeContactApiSubscription: Subscription;
  contact_number: any;
  countryCode: any;
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public popupData: any,
    private _mdlSnackbarService: SnackbarService,
    private _phoneFollowUpPopupService: PhoneFollowUpPopupService
  ) { }

  _contactPhone = () => {
    this.loading = true;
    this.makeContactApiSubscription?.unsubscribe();
    this.makeContactApiSubscription = this._phoneFollowUpPopupService.makeContact(this.popupData.listData.id, this.popupData.type)
      .subscribe((res: any) => {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar('UPDATE_CONTACT_DETAIL_SUCCESS', 'success');
        this.dialogRef.close('updated');
      },
        (error: any) => {
          this.loading = false;
          this._mdlSnackbarService.showSnackbar('UPDATE_CONTACT_DETAIL_FAIL', 'error');
        });
  }

  ngOnInit() {
    switch(this.popupData.type) {
      case 'follow-up':
      case 'non-start-follow-up':
      case 'patient-follow-up':
        this.contact_number = this.popupData.listData.contact_number;
        this.countryCode = this.popupData.listData.country_code;
        break;

      case 'parent-follow-up':
      case 'vc-follow-up':
        this.contact_number = this.popupData.listData.patient.contact_number;
        this.countryCode = this.popupData.listData.country_code;
        break;

      case 'referral':
        this.contact_number = this.popupData.listData.user.contact_number;
        this.countryCode = this.popupData.listData.user.country_code.code;
        break;
    }
  }
}